import { fetchDisplayOrderModal, updateItemDisplayOrder } from "../HTTPRequests/ItemRequests";
import openErrorModal from "../Error/ErrorModal";
import { createLoadingScreen } from "../DomUtilities/ElementsCreator";
import Mediator from "../Utilities/Mediator";
import SortElementsByDrag from "../Utilities/SortElementsByDrag";

export default class DisplayOrderModal {
	loadingScreen: HTMLElement;
	modalDiv: HTMLDivElement;

	constructor() {
		this.loadingScreen = createLoadingScreen();
		this.modalDiv = document.createElement('div');
	}

	public addDisplayOrderIconClickListener() {
		const sortIcon: HTMLElement = document.querySelector('.text-header i');
		sortIcon.onclick = () => {
			sortIcon.classList.add('clicked');
			setTimeout(() => sortIcon.classList.remove('clicked'), 500);
			document.body.appendChild(this.loadingScreen);
			this.fetchModal();
		}
	}

	private fetchModal() {
		fetchDisplayOrderModal()
			.then((response: string) => {
				this.openModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openModal(modalHTMLString: string) {
		this.modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(this.modalDiv);

		this.addModalButtonsClickListeners();
		this.addDragListeners();
	}

	private addModalButtonsClickListeners() {
		const closeImage: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		const cancelButton: HTMLButtonElement = this.modalDiv.querySelector('button');
		const saveButton: HTMLButtonElement = this.modalDiv.querySelector('button + button');

		window.onclick = (event: MouseEvent) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}

		closeImage.onclick = () => {
			this.modalDiv.remove();
		}

		cancelButton.onclick = () => {
			this.modalDiv.remove();
		}

		saveButton.onclick = () => {
			document.body.appendChild(this.loadingScreen);
			this.saveDisplayOrder();
		}
	}

	private saveDisplayOrder() {
		const items: NodeListOf<HTMLDivElement> = this.modalDiv.querySelectorAll("ul#all-items > li");
		let numberOfTasks: number = 0;
		let numberOfCompletedTasks: number = 0;
		items.forEach((item, index) => {
			const itemIndex: number = parseInt(item.dataset.itemIndex);
			if (itemIndex != index) {
				numberOfTasks++;
				updateItemDisplayOrder(item.id, (index + 1))
					.then(() => {
						numberOfCompletedTasks++;
						if (numberOfCompletedTasks === numberOfTasks) {
							Mediator.emit("itemCrudOperationFinished");
						}
					}, () => { //backend error
						openErrorModal();
					}).catch(() => { //frontend error
						openErrorModal();
					}).finally(() => {
						this.loadingScreen.remove();
						this.modalDiv.remove();
					});
			}
		});
		if (numberOfCompletedTasks === numberOfTasks) {
			Mediator.emit("itemCrudOperationFinished");
			this.modalDiv.remove();
			this.loadingScreen.remove();
		}
	}

	private addDragListeners() {
		const itemsList = document.getElementById('all-items');
		new SortElementsByDrag(itemsList);
	}
}
